import { styled, theme } from "@theme/stitches.config"

export const FormMessageWrapper = styled("div", ({
    backgroundColor: theme.colors.R200,
    color: theme.colors.R500,
    padding: "8px 12px",
    lineHeight: 1.715,
    fontWeight: theme.fontWeights.bold,
    fontSize: theme.fontSizes.desktopBody,
    marginTop: 24,
    marginBottom: 24,
    a: {
        textDecoration: "underline"
    },
    "&:first-child": {
        marginTop: 0
    },
    "&:last-child": {
        marginBottom: 0
    },
    "@mdDown": {
        fontSize: theme.fontSizes.desktopBody,
        marginTop: 16,
        marginBottom: 16,
        "&:first-child": {
            marginTop: 0
        },
        "&:last-child": {
            marginBottom: 0
        }
    },
    variants: {
        dense: {
            true: {
                lineHeight: 1.375,
                fontSize: theme.fontSizes.desktopBody,
                fontWeight: theme.fontWeights.regular,
                "@mdDown": {
                    fontSize: theme.fontSizes.desktopSmall
                }
            }
        },
        type: {
            success: {
                backgroundColor: theme.colors.G200,
                color: theme.colors.G500
            }
        }
    }
}))
